import { render } from "./pagebreadcrumb.vue?vue&type=template&id=37d1d61a"
import script from "./pagebreadcrumb.vue?vue&type=script&lang=js"
export * from "./pagebreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__